import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { QueryClientProvider } from '@tanstack/react-query';
import awsExports from './aws-exports';
import queryClient from './queryClient';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const isCapacitorNative = typeof window !== 'undefined' &&
  window.location.href.startsWith('capacitor://');
const webOrigin = typeof window !== 'undefined' ? window.location.origin : '';

const redirectBase = isCapacitorNative ? 'capacitor://localhost' : webOrigin;

// Exclude identityPoolId — the app uses COGNITO_USER_POOLS auth (idToken),
// not Identity Pool credentials, and the pool disallows unauthenticated access.
const { aws_cognito_identity_pool_id: _ignoreIdPool, ...awsConfig } = awsExports;

// Use the app client (not web client) — it has OAuth + SignInWithApple configured.
// The web client (aws_user_pools_web_client_id) has OAuth disabled.
const USER_POOL_CLIENT_ID = '6gjefcmh2pjuac27iirc0ji90s';

Amplify.configure({
  ...awsConfig,
  Auth: {
    Cognito: {
      userPoolId: awsExports.aws_user_pools_id,
      userPoolClientId: USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: 'docket-tasks.auth.eu-west-2.amazoncognito.com',
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [`${redirectBase}/auth/callback`],
          redirectSignOut: [`${redirectBase}/`],
          responseType: 'code',
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
